<template>
    <component :is="template">
        <v-container>
            <div class="contents-area">
                <div class="contents-area__inner mx-auto" style="max-width:800px">
                    <div class="tit-wrap tit-wrap--unberline">
                        <h2 class="tit">상품권 교환소</h2>
                        <div class="mt-4px mt-lg-8px font-size-14 font-size-md-16 grey--text text--garken-3">
                            교환권번호를 입력하여 나누리 캐시로 교환하실 수 있습니다.
                        </div>
                    </div>

                    <v-layout justify-center>
                        <v-sheet width="100%" max-width="720">
                            <template v-if="mode == 'form' || !$vuetify.breakpoint.mobile">
                                <exchange-codes
                                    v-model="form.exchanges"
                                    v-bind="{
                                        mode,
                                        code,
                                        loading,
                                    }"
                                />
                            </template>

                            <template v-if="mode == 'form'">
                                <exchange-items
                                    v-model="form.exchanges"
                                    v-bind="{
                                        code,
                                    }"
                                    class="mt-10"
                                />
                                <div class="py-20px py-md-40px">
                                    <v-row class="row--small" justify="center">
                                        <v-col :cols="$vuetify.breakpoint.mobile ? '6' : 'auto'">
                                            <v-btn v-bind="{ disabled: disabled_save }" rounded large block color="primary" class="white--text w-lg-160px" @click="save">
                                                <span> 상품권 교환하기 </span>
                                            </v-btn>
                                        </v-col>
                                        <v-col :cols="$vuetify.breakpoint.mobile ? '6' : 'auto'">
                                            <v-btn rounded large outlined block color="primary" class="w-lg-160px border-3" to="/mypage/exchange">
                                                <span class="black--text"> 교환내역 조회 </span>
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </div>
                            </template>
                            <template v-if="mode == 'view'">
                                <exchange-table v-model="form.exchanges" class="mt-10" />
                                <div class="py-20px py-md-40px">
                                    <v-row class="row--small" justify="center">
                                        <v-col :cols="$vuetify.breakpoint.mobile ? '6' : 'auto'">
                                            <v-btn rounded large block color="primary" class="white--text w-lg-160px" v-bind="{ disabled: disabled_exec }" @click="execCash">
                                                <span> 바로 충전하기 </span>
                                            </v-btn>
                                        </v-col>
                                        <v-col :cols="$vuetify.breakpoint.mobile ? '6' : 'auto'">
                                            <exchange-gifts v-bind="{ amount }" v-on="{ exec: execGift }" v-slot="{ attrs, on }" ref="exchange-gifts">
                                                <v-btn rounded large outlined block color="primary" class="w-lg-160px border-3" v-bind="{ ...attrs, disabled: disabled_exec }" v-on="on">
                                                    <span class="black--text"> 선물하기 </span>
                                                </v-btn>
                                            </exchange-gifts>
                                        </v-col>
                                    </v-row>
                                </div>
                            </template>
                        </v-sheet>
                    </v-layout>

                    <template v-if="mode == 'form'">
                        <v-divider class="my-20px my-lg-40px" />
                        <exchange-excel v-model="form.exchanges" v-bind="{ code }" />
                    </template>

                    <v-divider class="my-20px my-lg-40px" />
                    <exchange-alert />
                </div>
            </div>
        </v-container>
        <common-loader v-bind="{ loading }" />
    </component>
</template>

<script>
import api from "@/api";
import { mapActions } from "vuex";
import { initUserExchange, initUserExchangeBulk, USER_EXCHANGE_CODES } from "@/assets/lib";

import CommonLoader from "@/components/common/common-loader.vue";
import ExchangeAlert from "@/components/client/exchange/exchange-alert.vue";
import ExchangeCodes from "@/components/client/exchange/exchange-codes.vue";
import ExchangeExcel from "@/components/client/exchange/exchange-excel.vue";
import ExchangeGifts from "@/components/client/exchange/exchange-gifts.vue";
import ExchangeItems from "@/components/client/exchange/exchange-items.vue";
import ExchangeTable from "@/components/client/exchange/exchange-table.vue";

export default {
    components: {
        CommonLoader,
        ExchangeAlert,
        ExchangeCodes,
        ExchangeExcel,
        ExchangeGifts,
        ExchangeItems,
        ExchangeTable,
    },
    props: {
        code: { type: String, default: USER_EXCHANGE_CODES.AUCTION.value.toLowerCase() },
    },
    data: () => ({
        /** @type {'form'|'view'} */
        mode: "form",

        form: initUserExchangeBulk(),

        loading: false,
    }),
    computed: {
        template() {
            return () => import(`@/templates/${this.$theme.pages.gshop}`);
        },

        /** @type {import('vue/types').ComputedOptions<number>} */
        amount() {
            return this.form.amount;
        },

        /** @type {import('vue/types').ComputedOptions<boolean>} */
        disabled_save() {
            return this.form.exchanges.some((item) => !/^\d{20}$/.test(item.prev));
        },

        /** @type {import('vue/types').ComputedOptions<boolean>} */
        disabled_exec() {
            return (this.form.gifted && !this.failedToGift) || (this.form.cashed && !this.form.failedToCash);
        },
    },
    methods: {
        ...mapActions(["getUser"]),

        init() {
            this.mode = "form";
            let code = this.code.toUpperCase();

            switch (code) {
                // case USER_EXCHANGE_CODES.TESTCODE.value: {
                //     this.form = initUserExchangeBulk({
                //         code,
                //         exchanges: new Array(1).fill().map(() => initUserExchange({ code, prev: `${Math.random().toFixed(20)}`.slice(2) })),
                //     });

                //     break;
                // }

                default: {
                    this.form = initUserExchangeBulk({
                        code,
                        exchanges: [initUserExchange({ code })],
                    });
                    break;
                }
            }

            this.loading = false;
        },
        async save() {
            if (!this.$store.state.payload?._user) {
                alert("로그인 후 사용하실 수 있는 기능입니다.");
                return;
            }

            if (this.loading) return;
            else this.loading = true;

            try {
                this.mode = "view";

                let { ...form } = this.form;
                let { bulk } = await api.v1.me.exchanges.bulks.post(form);
                this.form = initUserExchangeBulk(bulk);
                if (this.form.errorMessage == "핀교환 10회 실패로 인하여 ID 접근 차단 및 로그아웃 처리되었습니다. \n재로그인 시 본인인증을 진행하셔야 합니다.") {
                    alert(this.form.errorMessage);
                    this.$store.dispatch("logout");
                }
            } finally {
                this.loading = false;
            }
        },

        async execCash() {
            let { amount } = this;
            let go = confirm(`${amount.format()}원을 나누리 캐시로 바로 충전하시겠습니까?`);
            if (!go) return;

            if (this.loading) return;
            else this.loading = true;

            try {
                let { bulk } = await api.v1.me.exchanges.bulks.cash.postExec({
                    _id: this.form._id,
                    withoutPrev: true,
                    nullifyNext: false,
                });

                this.form = initUserExchangeBulk(bulk);

                this.getUser();

                let message = "";

                let items_success = this.form.exchanges.filter((item) => item.cashed && !item.failedToCash);
                let successAmount = items_success.reduce((sum, item) => sum + item.amount, 0);

                let items_failure = this.form.exchanges.filter((item) => !item.cashed || item.failedToCash);
                if (0 < items_failure.length) {
                    let totalCount = this.form.exchanges.length;
                    let successCount = items_success.length;

                    message = `${totalCount.format()}건 중 ${successCount.format()}건 충전하기에 성공했습니다.`;
                } else {
                    message = `나누리 캐시 충전에 성공했습니다.`;
                }

                message += `\n\n충전 금액: ${successAmount.format()}원\n\n자세한 내용은 ‘마이페이지 > 나누리캐시 > 캐시내역’에서 확인하실 수 있습니다.`;

                alert(message);
            } finally {
                this.loading = false;
            }
        },
        async execGift({ phone }) {
            if (this.loading) return;
            else this.loading = true;

            try {
                let { bulk } = await api.v1.me.exchanges.bulks.gift.postSend({
                    _id: this.form._id,
                    phone: phone,
                    withoutPrev: true,
                    nullifyNext: false,
                });
                this.form = initUserExchangeBulk(bulk);

                let message = "";

                let items_success = this.form.exchanges.filter((item) => item.done && !item.fail);
                let successAmount = items_success.reduce((sum, item) => sum + item.amount, 0);

                let items_failure = this.form.exchanges.filter((item) => !item.done || item.fail);
                if (0 < items_failure.length) {
                    let totalCount = this.form.exchanges.length;
                    let successCount = items_success.length;

                    message = `${totalCount.format()}건 중 ${successCount.format()}건 선물하기에 성공했습니다.`;
                } else {
                    message = `입력하신 연락처로 자동충전URL을 보냈습니다.`;
                }

                message += `\n\n받는 사람: ${phone.phoneNumberFormat()}\n보낸 금액: ${successAmount.format()}원\n\n자세한 내용은 ‘마이페이지 > 상품권 교환소 > 교환 내역’에서 확인하실 수 있습니다.`;

                alert(message);

                this.$refs["exchange-gifts"].exit();
            } finally {
                this.loading = false;
            }
        },
    },
    watch: {
        code() {
            this.init();
        },
    },
    mounted() {
        this.init();
    },
};
</script>

<style lang="scss" scoped>
.exchange-list-item-card__overlay {
    position: absolute;
    bottom: 0;
    width: 100%;

    align-items: end;
    justify-content: stretch;

    &::v-deep .v-overlay__content {
        width: 100%;
    }
}
</style>
